import React, {useContext} from 'react'
import { AppDataContext } from 'contexts/appData';
const BlockedReason = (props) => {
	const { appData } = useContext(AppDataContext);
	return (
    <>
      <div className="mb-24px custom-modal-wrapper">
				<h3 className="blocked-reason-text font-size-16 font-bold-caps text-dark text-center mb-24px pt-32px pt-md-16px">
					{`${props.langs.BlockReason}:`}
				</h3>
				{props.data.reason?.map((reason, i) => (
					<div className="blocked-alert d-block w-100 mt-16px p-12px" key={i}>
						<div className="d-flex align-items-start gap-12px">
							<i className="svg-i info-grey-icon-i w-16px h-16px flex-shrink-0"></i>
							<div className="blocked-alert-text font-size-14 font-medium">
								{appData.BlockReasons[reason]}
							</div>
						</div>
					</div>
				))}
			</div>
      <div className=" mt-0">
				<button type="button" className="font-size-14 font-base-caps px-64px py-16px btn bg-middle-gray   text-blue-gray d-block mx-auto " onClick={e => props.callback(e, 'destroy')}>
					{props.langs.Close}
				</button>
			</div>
    </>
  )
}

export default BlockedReason;
